import script from "./ContactSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactSection.vue?vue&type=script&setup=true&lang=js"

import "./ContactSection.vue?vue&type=style&index=0&id=6cc96ebc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cc96ebc"]])

export default __exports__